export default __webpack_public_path__ + "static/media/foto1.3f84655f.jpg";